import { createTheme, Theme } from '@mui/material/styles'

export const theme: Theme = createTheme({
  palette: {
    primary: {
      main: '#41c041',
    },
    secondary: {
      main: '#545454',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          // background: 'red',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            transitionDelay: '9999s',
            transitionProperty: 'background-color, color',
          },
        },
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: 'rgba(255, 255, 255, 0.87)',
          fontSize: 12,
        },
      },
    },
  },
}) 